import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/logos/Vue.svg?component
var Vue_exports = /* @__PURE__ */ __exportAll({
	default: () => Vue_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "#41B883",
		d: "m14.31 4.34-2.31 4-2.31-4H2l10 17.32L22 4.34z"
	}, null, -1), createElementVNode("path", {
		fill: "#34495E",
		d: "m14.31 4.34-2.31 4-2.31-4H6l6 10.392L18 4.34z"
	}, null, -1)])]);
}
var Vue_default = { render: render$1 };
//#endregion
export { Vue_exports, Vue_default as default, render$1 as render };

//# sourceMappingURL=Vue.svg_component.js.map